export default __webpack_public_path__ + "static/flower-3dedf5c95a11e04f4b0a33e1b824e0cc.svg";